module.exports = __webpack_public_path__ + "static/media/gandhi.7c3aeb21.png";